
import { defineComponent } from 'vue'
import { appendOpenBrowserToUrl } from '@/utils/xpEnv'

export default defineComponent({
  props: {
    na: String
  },
  setup() {
    function gotobrowser() {
      let url: string = appendOpenBrowserToUrl(location.href)
      url = url.replace('os=xp', 'os=pdf')
      window.open(`gw://openurl?param=${url}`)
    }
    return {
      gotobrowser
    }
  }
})
